import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Accordion, Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { api } from '../../store/api';
import ContactListCard from '../acts/components/ContactListTable';
import Page from '../app/Page';
import AccountAddressListCard from '../shared/components/AccountAddressListCard';
import BookingSummaryTable from '../shared/components/BookingSummaryTable';
import LegacyBookingCard from './components/LegacyBookingCard';
import EditableClientNameHeader from '../shared/components/editable/EditableClientNameHeader';

const ClientDetailPage = () => {
    const { id = '0' } = useParams();
    const { data: client } = api.useGetClientQuery(+id ?? skipToken);
    const { data: legacyBookingIds } = api.useGetClientLegacyBookingIdsQuery(+id ?? skipToken);
    const { data: bookings, isLoading, isFetching } = api.useGetClientBookingsQuery(+id ?? skipToken);

    return (
        <Page>
            <Container fluid>
                {client && <EditableClientNameHeader accountId={client.id} name={client.name} />}
                <Tabs>
                    <Tab eventKey="client" title="Client Detail">
                        <Row>
                            <Col>{client && <ContactListCard entity={client} />}</Col>
                        </Row>
                        <Row>
                            <Col md={4}>{client && <AccountAddressListCard accountId={client.id} />}</Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="bookings" title="Bookings">
                        <Row>
                            <Col>
                                <BookingSummaryTable data={bookings} isLoading={isLoading || isFetching} />
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="approach" title="Approach Bookings">
                        <Row>
                            <Col lg={8}>
                                <Accordion>
                                    {legacyBookingIds?.map((x) => (
                                        <Accordion.Item key={x} eventKey={x.toString()}>
                                            <LegacyBookingCard legacyBookingId={x} />
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </Col>
                        </Row>
                    </Tab>
                </Tabs>
            </Container>
        </Page>
    );
};

export default ClientDetailPage;
